import validator from 'validator';

export function validateEmail(email) {
    if (!validator.isEmail(email)) {
      return 'Please enter a valid email address.';
    } else {
      return null;
    }
};